import React from "react";
import { useRoutes } from "react-router-dom";
import { Provider } from "react-redux";
import { HelmetProvider, Helmet } from "react-helmet-async";
import { CacheProvider } from "@emotion/react";

import { ThemeProvider as MuiThemeProvider } from "@mui/material/styles";

import "./i18n";
import createTheme from "./theme";
import getRoutes from "./routes";
import useTheme from "./hooks/useTheme";
import { store } from "./redux/store";
import createEmotionCache from "./utils/createEmotionCache";
import { SnackbarProvider } from "notistack";

import { AuthProvider } from "./contexts/JWTContext";
import { hasChatbotAccess } from "./config/featureAccess";
import "react-image-lightbox/style.css";
import "./App.css";
import DifyChatbot from "./DifyChatbot";

const clientSideEmotionCache = createEmotionCache();

function App({ emotionCache = clientSideEmotionCache }) {
  const user = JSON.parse(localStorage.getItem("user"));
  const { theme } = useTheme();
  const content = useRoutes(getRoutes(user?.user));

  return (
    <CacheProvider value={emotionCache}>
      <HelmetProvider>
        <Helmet titleTemplate="%s | LK" defaultTitle="LK System" />
        <Provider store={store}>
          <MuiThemeProvider theme={createTheme(theme)}>
            <SnackbarProvider
              autoHideDuration={1500}
              maxSnack={5}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
              }}
            >
              <AuthProvider>
                {user && hasChatbotAccess(user?.user) && <DifyChatbot />}
                {content}
              </AuthProvider>
            </SnackbarProvider>
          </MuiThemeProvider>
        </Provider>
      </HelmetProvider>
    </CacheProvider>
  );
}

export default App;
